import { useMutation as useMutationBase, } from '@tanstack/react-query';
import { request } from '../../request';
export function useMutation(query, options, responseMapper = (response) => response, endpoint) {
    return useMutationBase({
        mutationFn: async (variables) => {
            const response = await request({
                query,
                variables,
                endpoint,
            });
            return responseMapper(response);
        },
        ...options,
    });
}
;
//# sourceMappingURL=useMutation.js.map